var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"investor-article"},[_c('h2',[_c('router-link',{attrs:{"to":{name:'investor-article-view',params:{slug:_vm.article.slug}}}},[_vm._v(_vm._s(_vm.article.title))])],1),_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.article.created)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }